export default {
  minimum: 1.0,
  maximum: 5.0,
  style: 3,
  mask: '0'
};